import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the qualitativeQuestionList state domain
 */

const selectQualitativeQuestionListDomain = (state) =>
  state.get("qualitativeQuestionListInside", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoadingAnswers = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("isLoadingAnswers")
  )

export const makeSelectAnswers = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("answers")
  )

export const makeSelectIsLoadingAnswersWordCloud = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("isLoadingWordCloud")
  )

export const makeSelectWordCloud = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("wordCloud")
  )

export const makeSelectIsLoadingSentimentWordcloud = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("isLoadingSentimentWordcloud")
  )

export const makeSelectSentimentWordcloud = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("sentimentWordcloud")
  )

export const makeSelectSentimentTotalAnswers = () =>
  createSelector(selectQualitativeQuestionListDomain, (state) =>
    state.get("sentimentTotalAnswers")
  )
/**
 * Default selector used by QualitativeQuestionList
 */

const makeSelectQualitativeQuestionList = () =>
  createSelector(selectQualitativeQuestionListDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectQualitativeQuestionList
export { selectQualitativeQuestionListDomain }
